module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/aleg48-a831bb912b0c7f1496ef3172d044f9ac.jpg";